import {
  ERROR_PERMISSION,
  GET_ALL_PERMISSIONS,
  SET_LOADING_PERMISSION,
  SET_SELECTED_ORG,
  SET_SELECTED_ROLE,
  USER_INFO,
} from '../types';
import axiosInstance from '../request';

export const getAllPermissions = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_PERMISSION });
    const { data } = await axiosInstance.get(`/manage/options/`);
    console.log(data);
    dispatch({
      type: USER_INFO,
      payload: { username: data.username, fullname: data.full_name },
    });
    dispatch({
      type: GET_ALL_PERMISSIONS,
      payload: convertRoles(data.roles),
    });
  } catch (e) {
    dispatch({
      type: ERROR_PERMISSION,
      payload: e.response,
    });
  }
};

export function clearSelectedPermission() {
  return async dispatch => {
    try {
      dispatch({
        type: SET_SELECTED_ROLE,
        payload: null,
      });
      dispatch({
        type: SET_SELECTED_ORG,
        payload: null,
      });
    } catch (e) {}
  };
}

export function clearPermissions() {
  return async dispatch => {
    try {
      dispatch({
        type: GET_ALL_PERMISSIONS,
        payload: null,
      });
    } catch (e) {}
  };
}

export const changeSelectedRole = role => async dispatch => {
  dispatch({
    type: SET_SELECTED_ROLE,
    payload: role,
  });
};

export const changeSelectedOrg = org => async dispatch => {
  dispatch({
    type: SET_SELECTED_ORG,
    payload: org,
  });
};

function convertRoles(items) {
  let roles = [...items];
  let temp = [];

  let hasOrg = org => {
    let flag = false;

    for (let i = 0; i < temp.length; i++) {
      if (org.id == temp[i].organization.id) {
        flag = true;
        break;
      }
    }
    return flag;
  };

  roles.forEach(item => {
    let { id, name, translated_name, organization } = item;

    if (hasOrg(organization)) {
      temp.forEach(i => {
        if (i.organization.id == organization.id) {
          i.roles.push({ id, name, translated_name });
        }
      });
    } else {
      temp.push({ roles: [{ id, name, translated_name }], organization });
    }
  });

  return temp;
}
